import { CellType, Link } from './types';

export function isLinkType(cell: CellType): cell is Link {
  return typeof cell === 'object';
}
